<template>
  <div class="hero-searchbar">
    <div class="search-input-wrapper">
      <span class="search-icon">🔍</span>
      <input
        v-model="searchQuery"
        type="text"
        placeholder="Search..."
        @keyup.enter="emitSearch"
      />
    </div>
    <button class="search-button" :class="{ 'iwc-button': isIwcRoute }" @click="emitSearch">
      Search Member Name
    </button>
  </div>
</template>

<script>
import { ref, computed  } from "vue";
import { useRoute } from "vue-router";
export default {
  name: "HeroSearchbar",
  setup(props, { emit }) {
    const searchQuery = ref("");
    const route = useRoute();

    const emitSearch = () => {
      emit("search", searchQuery.value);
    };

    const isIwcRoute = computed(() => route.path.startsWith("/iwc"));

    return {
      searchQuery,
      emitSearch,
      isIwcRoute,
    };
  },
};
</script>

<style scoped>
.hero-searchbar {
  display: flex;
  align-items: stretch;
  gap: 10px;
  flex-wrap: wrap;
}

@media (max-width: 600px) {
  .hero-searchbar {
    flex-direction: column;
  }

  .search-button {
    width: 100%;
  }
}

.search-input-wrapper {
  display: flex;
  align-items: center;
  border: 2px solid #a3dff7;
  border-radius: 8px;
  padding: 6px 10px;
  background-color: white;
  flex: 1;
}

.search-icon {
  color: #888;
  margin-right: 6px;
}

.search-input-wrapper input {
  border: none;
  outline: none;
  width: 100%;
  font-size: 17px;
  color: #333;
}

.search-button {
  background-color: #f59e0b;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.search-button:hover {
  background-color: #d97706;
}

.iwc-button {
  background-color: #3f9c35;
}

.iwc-button:hover {
  background-color: #34732d; 
}
</style>
